import { useQuery } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function fetchDigitalAssetDefinition({ page, limit, filters = [] }) {
  try {
    const url = paths.fetchDigitalAssetDefinitions();

    const payload = {
      input: {
        offset: page * limit,
        limit: limit,
        filters: filters,
      },
    };

    const response = await axiosInstance.post(url, payload);
    return response.data?.data || [];
  } catch (error) {
    console.error("Digital asset definition fetch failed:", error?.response?.data || error);
    return Promise.reject(error);
  }
}

const useDigitalAssetDefinition = (params, options = {}) => {
  return useQuery({
    queryKey: ['digitalAssetDefinitions', params],
    queryFn: () => fetchDigitalAssetDefinition(params),
    enabled: true, // Always enabled, params can be empty for initial load
    ...options
  });
};

export { useDigitalAssetDefinition };